<template>
    <span class="icon" :class="[{'is-spinning': spinning, 'is-prominent': prominent, 'justify-center': center}, colorString ? 'text-' + colorString : '']" aria-hidden="true" @click="$emit('click')"
          :style="iconStyle">
        <svg xmlns="http://www.w3.org/2000/svg" :viewBox="'0 0 24 24'" :height="computedSize" :width="computedSize" role="img" aria-hidden="true" :style="iconStyle">
            <path :d="icon"></path>
        </svg>

    </span>
</template>

<script>
import IconMixin from "./IconMixin";

    export default {
        name: 'Icon',

        mixins: [IconMixin],

		emits: ['click'],

        props: {

            // The name of the icon to show
            icon: {
                type: String,
                required: true
            },

            // Whether to center the icon
            center: {
                type: Boolean,
                default: false
            },

            // Whether the icon size shall be forced so it can not be overwritten by other stylings
            forceSize: {
                type: Boolean,
                default: false
            },

            // Whether the icon shall retrieve a light background
            prominent: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            computedSize() {
                switch (this.sizeString) {
                    case '2xs':
                        return 14;
                    case 'xs':
                        return 16;
                    case 'sm':
                        return 20;
                    case 'lg':
                        return 28;
                    case 'xl':
                        return 32;
                    case '2xl':
                        return 36;
                }

                return this.size;
            },

            iconStyle() {
                const style = {}
                if (this.forceSize || this.prominent) {
                    style.width = this.computedSize + 'px';
                    style.height = this.computedSize + 'px';
                }
                if (this.colorHex) {
                    style.color = this.colorHex;
                }

                return style;
            }
        }
    }
</script>

<style>
@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.icon {
  display: flex;
  align-items: center;
  fill: currentColor;
  position: relative;
}
.icon.is-spinning {
  -webkit-animation: spin 0.8s linear infinite;
  -moz-animation: spin 0.8s linear infinite;
  animation: spin 0.8s linear infinite;
}
.icon.is-prominent:after {
  background: currentColor;
  border-radius: 50%;
  content: "";
  left: 50%;
  opacity: 0.16;
  position: absolute;
  top: 50%;
  width: 175%;
  height: 175%;
  transform: translate(-50%, -50%);
}
</style>
